module.exports = __webpack_public_path__ + "img/asistencia-remota.71ba7400.png";